import { useMemo, useState } from "react";

// Layout
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import FloatingButtons from "./components/ui/FloatingButtons";

// Pages
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import VisionMission from "./pages/VisionMission";
import NewsEvents from "./pages/NewsEvents";
import HospitalGallery from "./pages/HospitalGallery";
import FaqsComplaints from "./pages/FaqsComplaints";
import Packages from "./pages/Packages";
import DoctorDetails from "./pages/DoctorDetails";
import Corporate from "./pages/Corporate";
import Contact from "./pages/Contact";
import Branches from "./pages/Branches";
import Specialties from "./pages/Specialties";
import CareerDetails from "./pages/CareerDetails";
import CareerApply from "./pages/CareerApply";
import Services from "./pages/Services";
import InPatientServices from "./pages/InPatientServices";
import OutPatientServices from "./pages/OutPatientServices";

// SEO
import usePageSeo from "./hooks/usePageSeo";
import SEO from "./data/seo";

// Styles
import "./styles/global.css";
import "./styles/shared.css";

const PAGES = {
  home: Home,
  "about-us": AboutUs,
  "about-vision-mission": VisionMission,
  "about-news-events": NewsEvents,
  "about-gallery": HospitalGallery,
  "about-faqs-complaints": FaqsComplaints,
  services: Services,
  "services-inpatient": InPatientServices,
  "services-outpatient": OutPatientServices,
  packages: Packages,
  "doctor-details": DoctorDetails,
  specialties: Specialties,
  corporate: Corporate,
  contact: Contact,
  branches: Branches,
  "career-details": CareerDetails,
  "career-apply": CareerApply,
};

export default function App() {
  const [route, setRoute] = useState({ key: "home", params: {} });

  const navigate = (key, options = {}) => {
    const { scrollToTop = true, params = {} } = options || {};
    setRoute({ key, params });
    if (scrollToTop) window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const CurrentPage = PAGES[route.key] || Home;
  usePageSeo(SEO[route.key] || SEO.home);
  const navPage = useMemo(() => {
    if (route.key === "career-details" || route.key === "career-apply") return "branches";
    if (route.key === "doctor-details") return "packages";
    if (route.key.startsWith("about-")) return "about";
    if (
      route.key === "services-inpatient" ||
      route.key === "services-outpatient"
    ) {
      return "services";
    }
    return route.key;
  }, [route.key]);

  return (
    <div className="app">
      <div className="top-ticker" aria-live="polite">
        <div className="top-ticker__track">
          <span className="top-ticker__item">Welcome to Capital Care International Hospital</span>
        </div>
      </div>

      <Navbar page={navPage} setPage={navigate} route={route} />

      <main>
        <CurrentPage setPage={navigate} route={route} />
      </main>

      <Footer setPage={navigate} />
      <FloatingButtons />
    </div>
  );
}
